/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Bot_Never_6Inputs */

const en_bot_never_6 = /** @type {(inputs: Bot_Never_6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Train Bystep AI models on your content.`)
};

const id_bot_never_6 = /** @type {(inputs: Bot_Never_6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Melatih model AI milik Bystep dengan konten situs Anda.`)
};

/**
* | output |
* | --- |
* | "Train Bystep AI models on your content." |
*
* @param {Bot_Never_6Inputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const bot_never_6 = /** @type {((inputs?: Bot_Never_6Inputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Bot_Never_6Inputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_bot_never_6(inputs)
	return en_bot_never_6(inputs)
});